import React from "react";
import PT from "prop-types";
import styled from "styled-components";
import { BlobBlock, Title, AsideIcon } from "./index-styled";
import ClockIcon from "_c/icon/Clock";
import AsideSchedule from "_c/modules/profile/common/AsideSchedule";
import { analyticsAction } from "@/utils/analytics";

const Block = styled(BlobBlock)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: auto;
  @media (max-width: 991px) {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const EnhancedTitle = styled(Title)`
  margin-bottom: 30px;
  align-self: flex-start;
  @media (max-width: 991px) {
    align-self: auto;
    margin-bottom: 35px;
  }
  @media (max-width: 575px) {
    align-self: auto;
    margin-bottom: 15px;
  }
`;
const ScheduleBlock = (props) => {
  const onShowSlotsClick = () => {
    props.openFreeSlots();
    analyticsAction({
      category: "profile",
      action: "free_time_click",
    });
  };
  return (
    <>
      <Block id="master_working_hours_sect" isOwner={props.isOwner}>
        <AsideIcon>
          <ClockIcon color="var(--font-color-emp)" />
        </AsideIcon>
        <EnhancedTitle>{props.t("common:working_hours")}</EnhancedTitle>
        <AsideSchedule
          t={props.t}
          scheduleLink="/master/settings/business_hours"
          isOwner={props.isOwner}
          weekSchedule={props.weekSchedule}
        />
        <div
          css={`
            text-align: center;
            width: 100%;
          `}
        >
          <button
            onClick={onShowSlotsClick}
            css={`
              margin-top: 15px;
              color: var(--color-cta);
              font-weight: 700;
            `}
          >
            {props.t("master_profile:show_free_slots")}
          </button>
        </div>
      </Block>
    </>
  );
};

ScheduleBlock.propTypes = {
  isOwner: PT.bool.isRequired,
  weekSchedule: PT.array,
  masterId: PT.string,
  history: PT.object,
  theme: PT.object,

  openFreeSlots: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default ScheduleBlock;
